import BaseTable from "./base-table";
import { makeStyles, Box } from "@material-ui/core";
export function CustomTable(props) {
  const { propsTable, children } = props;
  const { className, ...rest } = propsTable;
  const classes = useStyles();
  return (
    <BaseTable
      className={`${classes.custom_table} ${className}`}
      boxProps={{ style: { height: "calc(100vh - 200px)" } }}
      {...rest}
    >
      {children}
    </BaseTable>
  );
}

export function CustomCaption(props) {
  const { children } = props;
  const classes = useStyles();
  return (
    <Box component="caption" className={classes.caption}>
      {children}
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  custom_table: {
    "& caption": {
      padding: 0,
      position: "sticky",
      zIndex: 11,
      backgroundColor: theme.palette.info.light,
      color: theme.palette.getContrastText(theme.palette.info.light),
      [theme.breakpoints.only("xs")]: {
        captionSide: "bottom",
        bottom: 0,
      },
      [theme.breakpoints.up("sm")]: {
        captionSide: "unset",
        top: 0,
        backgroundColor: theme.palette.grey[200],
        color: theme.palette.getContrastText(theme.palette.grey[200]),
      },
    },
    "& > thead": {
      display: "none",
      [theme.breakpoints.up("sm")]: { display: "table-header-group" },
      "& > tr": {
        // backgroundColor: theme.palette.primary.main,
        "& > th": {
          // color: theme.palette.common.white,
          // backgroundColor: "inherit",
          border: "none",
          backgroundColor: `hsl(from ${theme.palette.primary.dark} h s calc(l + 76))`,
          color: theme.palette.text.primary,
          textAlign: "center",
          lineHeight: 1,
        },
      },
    },
    "& > tbody": {
      "& > tr": {
        display: "grid",
        alignItems: "end",
        gridAutoColumns: "1fr",
        gridAutoRows: "max-content",
        padding: "0rem 0.5rem",
        [theme.breakpoints.down("xs")]: {
          marginBottom: 24,
          borderTop: `1px solid ${theme.palette.divider}`,
          borderBottom: `1px solid ${theme.palette.divider}`,
          // backgroundColor: "transparent",
        },
        "&:hover": {
          backgroundColor: `hsl(from ${theme.palette.primary.main} h s calc(l + 64)) !important`,
        },
        [theme.breakpoints.up("sm")]: {
          display: "table-row",
          "&:nth-of-type(odd)": {
            // backgroundColor: theme.palette.action.hover,
          },
        },
        "& > td": {
          textAlign: "center",
          wordWrap: "break-word",
          [theme.breakpoints.down("xs")]: {
            textAlign: "start",
            border: "none",
            padding: "0.5rem 0",
          },
        },
      },
    },
  },
}));
